<mat-card-header>
  <div>
    <mat-card-title class="card-title">Quotas and seats won</mat-card-title>
    <ng-container *ngIf="!isFinal; else final">
      <mat-card-subtitle> Please note: votes for the Legislative Council are still being counted.
         The quotas won displayed are indicative and are based on first preference votes only.
          Seats won data will not be available until the Declaration of the Poll. For more information,
           see <a href="https://www.ecsa.sa.gov.au/voting/counting-the-votes-for-the-legislative-council">The Legislative
             Council count process</a>. </mat-card-subtitle>
    </ng-container>
    <ng-template #final>
      <mat-card-subtitle> The quota for this election was {{quotaVotes | number }} votes.
         For more information, see <a href="https://www.ecsa.sa.gov.au/voting/counting-the-votes-for-the-legislative-council">The
           Legislative Council count process</a>
      </mat-card-subtitle>
    </ng-template>
  </div>
</mat-card-header>

<table mat-table [dataSource]="dataSource">
  <!-- Expand column for Independents dropdown -->
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        *ngIf="isIndependentsRow(element)"
        (click)="toggleIndependents()"
        [attr.aria-label]="'Toggle independents expansion'"
      >
        <mat-icon>{{ isIndependentsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </td>
  </ng-container>
  <ng-container *ngFor="let col of columns; let i = index;" matColumnDef="{{col.column}}">
    <th mat-header-cell *matHeaderCellDef>
      <div *ngIf="col.isRightJustify===false">{{col.label}}</div>
      <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.label}}</div>
      <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.labelTwo}}</div>
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'independent-detail-row': isIndividualIndependent(element)}">
      <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
        <mat-icon class="party-colour" [ngStyle]="{'color': element.colourCode}"> rectangle </mat-icon>
      </div>
      <div [style.min-width.px]="col.minWidth" class="value-justify-right" *ngIf="col.isRightJustify&&col.isPercent===false">
        {{element[col.column]}}
      </div>
      <div [style.min-width.px]="col.minWidth" *ngIf="col.isRightJustify===false&&col.isColour===false">{{element[col.column]}}</div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'table-row': isSmallTable}"></tr>
</table>
